import { render, staticRenderFns } from "./SignupLinkButton.vue?vue&type=template&id=e2cf9e38&scoped=true&"
import script from "./SignupLinkButton.vue?vue&type=script&lang=js&"
export * from "./SignupLinkButton.vue?vue&type=script&lang=js&"
import style0 from "./SignupLinkButton.vue?vue&type=style&index=0&id=e2cf9e38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2cf9e38",
  null
  
)

export default component.exports